import _styled from "styled-components";
import { observer } from "mobx-react";
import Icon, { StyledIcon } from "../../Styled/Icon";
import ButtonAsLabel from "../../Styled/ButtonAsLabel";
import Box from "../../Styled/Box";
import Text from "../../Styled/Text";
import Spacing from "../../Styled/Spacing";
import { useTranslation } from "react-i18next";
import withControlledVisibility from "../HOCs/withControlledVisibility";
import MappableMixin from "../../ModelMixins/MappableMixin";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MapDataCount = observer(function (props) {
  const {
    t
  } = useTranslation();
  const {
    terria,
    viewState
  } = props;
  if (viewState.useSmallScreenInterface) {
    return null;
  }

  // Can't simply use number of items given they can exist in workbench
  // without being shown on map
  const numberOfDatasets = terria.workbench.items.filter(item => {
    if (MappableMixin.isMixedInto(item)) {
      return item.show;
    }
  }).length;
  const hasMapData = numberOfDatasets !== 0;
  const mapDataText = hasMapData ? t("countDatasets.mapDataState", {
    count: numberOfDatasets
  }) : t("countDatasets.noMapDataEnabled");
  return /*#__PURE__*/_jsx(_StyledBox, {
    $_css: "flex-shrink 0.5;",
    children: /*#__PURE__*/_jsxs(ButtonAsLabel, {
      light: hasMapData,
      children: [/*#__PURE__*/_jsx(Spacing, {
        right: 1
      }), /*#__PURE__*/_jsx(StyledIcon, {
        glyph: hasMapData ? Icon.GLYPHS.mapDataActive : Icon.GLYPHS.mapDataInactive,
        light: !hasMapData,
        dark: hasMapData,
        styledWidth: "20px"
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 2
      }), /*#__PURE__*/_jsx(Text, {
        semiBold: true,
        children: mapDataText
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 3
      })]
    })
  });
});
export default withControlledVisibility(MapDataCount);
var _StyledBox = _styled(Box).withConfig({
  displayName: "MapDataCount___StyledBox",
  componentId: "sc-kb0cbd-0"
})(["", ""], p => p.$_css);